import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import { saveAs } from "file-saver"
import * as Rx from "rxjs"
import { map } from "rxjs/operators"
import { request } from "../utils/http"
import type { HttpHeaders } from "./types"

export const saveAccountImageApi = (
    headers: Record<string, any>,
    accountId: string,
    file: any,
    type: string,
    terminalId?: Maybe<string>,
    id?: Maybe<string>,
    sortIndex?: Maybe<number>,
    label?: Maybe<string>
) => {
    return Rx.defer(() =>
        request({
            method: "POST",
            path: `/data/account/${accountId}/upload-image`,
            body: {
                content: file,
                type: type,
                ...(terminalId != null
                    ? {
                          terminalIDs: [terminalId],
                      }
                    : null),
                ...(id != null
                    ? {
                          id: id,
                      }
                    : null),
                ...(sortIndex != null
                    ? {
                          sortIndex: sortIndex,
                      }
                    : null),
                ...(label != null
                    ? {
                          label: label,
                      }
                    : null),
            },
            headers: headers,
        })
    )
}

export const uploadFileApiRequest = (headers: HttpHeaders, fileBase64: string, filename: string) => {
    return request({
        method: "POST",
        path: "/file",
        body: {
            content: fileBase64,
            filename: filename,
        },
        headers: headers,
    })
}

export const getCsvReportApi = (headers: Record<string, any>, id: string): Rx.Observable<any> =>
    Rx.defer(() =>
        request({
            method: "GET",
            path: `/file?type=card-program-batch-csv&batchId=${id}`,
            headers: headers,
            withResponseHeaders: true,
        })
    ).pipe(
        map(({ responseBody, responseHeaders }) => {
            const filename = responseHeaders.get("content-disposition").split("filename=")[1]
            const filetype = responseHeaders.get("content-type")
            const blob = new Blob([responseBody], {
                type: filetype,
            })
            return saveAs(blob, filename)
        })
    )
